// extracted by mini-css-extract-plugin
module.exports = {"rootDiv":"challenges_rootDiv__MxP_H","titleDiv":"challenges_titleDiv__Cswnq","descriptionDiv":"challenges_descriptionDiv__LF_Iy"};